import { RoleEnum } from '@acme/api';
import type { IconName } from '@acme/assets';
import type { OrganizationResponse, UserResponse } from '@acme/domains';
import { Button } from 'flowbite-react';
import { ReactNode } from 'react';
import {
  Navigation,
  NotificationsControl,
  OptionsControl,
  OrganizationInfo,
  UserSession,
} from './ui';

export { HelpSection } from './ui/helpSection';

export interface NavigationItem {
  label: string;
  iconName: IconName;
  path: string;
  disabled?: boolean;
}

interface SidebarProps {
  className?: string;
  onCreateApplication?: () => void;
  navigationItems: NavigationItem[];
  disabled?: boolean;
  user: UserResponse | null;
  isLoading: boolean;
  organization: OrganizationResponse | null;
  onLogout: () => void;
  children?: ReactNode;
  currentPath?: string;
  onNavigate?: (path: string) => void;
}

export const Sidebar = ({
  className,
  onCreateApplication,
  navigationItems,
  disabled = false,
  organization,
  user,
  isLoading,
  onLogout,
  children,
  currentPath,
  onNavigate,
}: SidebarProps) => {
  return (
    <div
      className={`bg-white drop-shadow-md w-80 flex flex-col p-4  ${className}`}
    >
      <div className="flex w-full items-center justify-between mb-4">
        <OptionsControl profileLinkPath="/profile" onNavigate={onNavigate} />
        <NotificationsControl notificationsLinkPath="/notifications" />
      </div>

      <OrganizationInfo
        user={user}
        organization={organization}
        isLoading={isLoading}
      >
        {organization?.role?.id === RoleEnum.Client && (
          <Button
            color="primary"
            onClick={onCreateApplication}
            disabled={disabled}
            className={`mt-6 justify-center text-base leading-5 font-medium`}
          >
            Создать заявку
          </Button>
        )}
      </OrganizationInfo>

      <Navigation
        className="flex-grow mb-4 mt-4"
        items={navigationItems}
        currentPath={currentPath}
      />

      {children}

      <UserSession authLinkPath="/auth" onLogout={onLogout} />
    </div>
  );
};
